import { INITIATE_EXPAND_ZONE, TOGGLE_ZONE, EXPAND_ZONE, CONTRACT_ZONE } from "../constants/actionTypes";

export const initiateExpandZone = (
  section,
  expandedZones = []
) => ({
  type: INITIATE_EXPAND_ZONE,
  section,
  expandedZones,
});

export const toggleZone = (section, zoneId) => ({
  type: TOGGLE_ZONE,
  section: section,
  zoneId: zoneId,
});

export const expandZone = (section, zoneId) => ({
  type: EXPAND_ZONE,
  section: section,
  zoneId: zoneId,
});

export const contractZone = (section, zoneId) => ({
  type: CONTRACT_ZONE,
  section: section,
  zoneId: zoneId,
});
